import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { IncDataSrcList } from '@/common/entities/incDataSrc/IncDataSrcList';
import { IncListList } from '@/common/entities/incList/IncListList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';

export const FilterDetail = () => {
  const { entityObj } = useEntityMgr();

  const tabSpecs = [{ id: 'infoTab', label: 'Info', content: <EntityForm /> }];

  tabSpecs.push(
    { id: 'incDataSrcTab', label: 'Inclusion Data Sources', content: <IncDataSrcList filterId={entityObj.id} /> },
    { id: 'incListTab', label: 'Inclusion Lists', content: <IncListList filterId={entityObj.id} /> },
  );

  tabSpecs.push(
    {
      id: 'propTab',
      label: 'Properties',
      content: <EntityPropList parentEntity="FILTER" parentEntityObj={entityObj} />,
    },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="FILTER" parentEntityId={entityObj.id} /> },
  );

  return <EntityDetail tabSpecs={tabSpecs} />;
};